export default __webpack_public_path__ + "static/vba-f7b7916351008133ecd89baed4bb9938.png";